import Modal from './Modal';
import { useTranslation } from 'react-i18next';
import {CleanUrl} from "../../../utils/cleanUrl";

const ModalImageUpload = (props) => {
    const { handleModal } = props;
    const { t, i18n } = useTranslation();
    const imagePath = CleanUrl(`${process.env.REACT_APP_BASE_URL}/${window.drupalDirectory}/`);

    return (
        <Modal>
            <div className="pweu-modal-overlay">
                <div className="pweu-modal pweu-modal--image-scanning">
                    <div className="pweu-close-modal" onClick={handleModal}>
                        <img src={imagePath + "delete--white.svg"} alt="" />
                    </div>
                    <div className="pweu-modal-content">
                        <h2 className='heading5'>{t("How to take a good photo")}</h2>
                        <div className='pweu-modal-grid'>
                            <div className='pweu-modal-item'>
                                <div className='pweu-modal-item--img'>
                                    <img src={imagePath + "camera.png"} alt="" />
                                </div>
                                <div className='pweu-modal-item--text'>
                                    <div className="photo-guide">
                                        <div className="photo-guide__item">
                                            {t("Only the product should appear in the photograph.")}
                                        </div>
                                        <div className="photo-guide__item">
                                            {t("Make sure that the label is in the foreground and the logo is clearly identifiable.")}
                                        </div>
                                        <div className="photo-guide__item">
                                            {t("Use the flash if it is dark.")}
                                        </div>
                                    </div>
                                    <span>{t("Please note, the size limit is 10 MB and files in JPG, PNG or HEIC format are allowed.")}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default ModalImageUpload;
